import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  const loc = useLocation();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-grain">
        <div className="text-sm text-[#5B6371]" data-testid="auth-loading">Lade …</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  return children;
}
